export const game1Value = (color, y, x) => ({
    type: 'GAME_1',
    color,
    y,
    x
});

const initialState = {
    type: 'GAME_1',
    color: '',
    y: '',
    x: ''
};

export default (state = initialState, action = {}) => {
    if (action.type === 'GAME_1') {
        return Object.assign({}, {type: action.type, color: action.color, y: action.y, x: action.x})
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/state/game1.js